import { render, staticRenderFns } from "./TagSummary.vue?vue&type=template&id=205b00ec&scoped=true&"
import script from "./TagSummary.vue?vue&type=script&lang=js&"
export * from "./TagSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b00ec",
  null
  
)

export default component.exports